module.exports = __webpack_public_path__ + "img/s3-1.fd00b90a.jpg";